import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'

import { Modal } from 'containers/misc'
import { OrganizationStateChange } from 'containers/forms/organizations'
import {
  AwardUnitMove,
  AwardUnitChangeMode
} from 'containers/forms/award-units'
import { AwardUnitSummary } from 'components/sections/award-units'
import { Module, Button } from 'components/misc'
import { modal } from 'redux/modules/app'
import { filterByRole } from 'redux/selectors/misc'
import { getActiveRole } from 'utils/token'
import { ROLES, CONFIGURATION_KEYS, ORGANIZATION_HIERARCHY } from 'constants/enums'
import OrganizationManageGOP from '../../../forms/organizations/OrganizationManageGOP/OrganizationManageGOP'

@connect(
  ({ auth, api }) => ({
    activeOrganization: auth.organization,
    configuration: api.configuration
  }),
  { modal }
)
class AwardUnitsOverview extends Component {
  static propTypes = {
    organizationStates: PropTypes.array,
    updateOrganizationState: PropTypes.func,
    removeOrganization: PropTypes.func,
    modal: PropTypes.func,
    data: PropTypes.object,
    configuration: PropTypes.object,
    activeOrganization: PropTypes.object,
    displaySettings: PropTypes.bool
  }

  static defaultProps = {
    displaySettings: true,
    data: {}
  }

  render() {
    const {
      displaySettings,
      data,
      activeOrganization,
      configuration
    } = this.props
    const role = getActiveRole(activeOrganization)

    const isOffline = get(
      configuration,
      `valuesByOrganizationId[${get(data, 'id')}][${CONFIGURATION_KEYS.offlineAu.id}].booleanValue`
    )

    const orgId = get(activeOrganization, 'id')
    const isGOPEnabled = get(
        configuration,
        `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isGOPEnabled.id}].booleanValue`
    )

    const actions = [
      {
        id: 1,
        label: "Change Organisation's state",
        intlKey: 'organisation.change_organisation_state',
        onClick: () => this.props.modal('organization-state-change'),
        iacOnly: false,
        oaOnly: false,
        roles: [ROLES.IF_STAFF_SUPER.u, ROLES.GBT.u, ROLES.NAO_STAFF.u]
      },
      {
        id: 2,
        label: 'Move Award Unit',
        intlKey: 'organisation.move_award_unit',
        onClick: () => this.props.modal('organization-move-to-another-parent'),
        iacOnly: false,
        oaOnly: true,
        roles: [
          ROLES.IF_STAFF_SUPER.u,
          ROLES.GBT.u,
          ROLES.NAO_STAFF.u,
          ROLES.IF_REGION.u,
          ROLES.OA.u,
          ROLES.SOA.u
        ]
      },
      {
        id: 3,
        label: "Change Award Unit's mode",
        intlKey: 'organisation.change_award_unit_mode',
        onClick: () => this.props.modal('organization-change-mode'),
        iacOnly: false,
        oaOnly: false,
        roles: [
          ROLES.IF_STAFF_SUPER.u,
          ROLES.GBT.u,
          ROLES.NAO_STAFF.u,
          ROLES.IF_REGION.u,
          ROLES.OA.u,
          ROLES.SOA.u
        ],
        hide: !isOffline
      },
      {
        id: 4,
        label: 'Manage Global Operating Partner',
        intlKey: 'organisation.manage_gop',
        onClick: () => this.props.modal('organization-manage-gop'),
        iacOnly: false,
        oaOnly: false,
        icOnly: true,
        negative: false,
        roles: [ROLES.IF_STAFF_SUPER.u, ROLES.GBT.u],
        hide: !isGOPEnabled
      },
      {
        id: 5,
        label: 'Remove organisation',
        intlKey: 'organisation.remove_organisation',
        onClick: () => this.props.modal('organization-remove'),
        iacOnly: true,
        oaOnly: false,
        negative: true,
        roles: [ROLES.IF_STAFF_SUPER.u, ROLES.GBT.u]
      }
    ]

    let actionRoles = filterByRole(actions, role)

    actionRoles = actions.filter(item => {
      if (item.oaOnly) {
        return Boolean(data.parentOA) || Boolean(data.parentSubOA)
      }

      if (item.icOnly) {
        return get(data, 'hierarchyLevel.value') === ORGANIZATION_HIERARCHY.IAC.value
      }
      return item
    })

    const isSettingsVisible = actionRoles.length > 0 && displaySettings
    const closeButton = (
      <div className="col-xs-6">
        <Button type="button" onClick={() => this.props.modal(null)} secondary>
          <FormattedMessage id="button.close" defaultMessage="Close" />
        </Button>
      </div>
    )

    return (
      <div>
        <Module
          title="Overview"
          intlKey="moduleTitle.overview"
          primary
          grid
          actionDropdown={isSettingsVisible ? 'Organisation Settings' : ''}
          actionDropdownActions={actionRoles}
          intlKeyAction="button.organisation_settings"
          iconAction="settings"
        >
          <AwardUnitSummary data={data} isOffline={isOffline} />
        </Module>

        <Modal
          id="organization-state-change"
          compact
          action="Select"
          intlKeyAction="modal.select"
          customActions
        >
          <OrganizationStateChange
            organizationStates={this.props.organizationStates}
            data={this.props.data}
            updateOrganizationState={this.props.updateOrganizationState}
          />
        </Modal>
        <Modal
          id="organization-move-to-another-parent"
          enableOverflow
          customActions
        >
          <AwardUnitMove data={data} onClose={() => this.props.modal(null)} />
        </Modal>
        <Modal id="organization-remove" compact customActions>
          <div className="row">
            <div className="col-xs-12">
              <h2 className="text--center">
                <FormattedMessage
                  id="organisation.where_would_you_like_to_remove"
                  defaultMessage="Where would you like to remove this organisation?"
                />
              </h2>
            </div>
            {closeButton}
            <div className="col-xs-6 text--right">
              <Button
                type="button"
                negative
                onClick={() => this.props.removeOrganization(data.id)}
              >
                <FormattedMessage id="button.remove" defaultMessage="Remove" />
              </Button>
            </div>
          </div>
        </Modal>
        <Modal id="organization-change-mode" compact customActions>
          <AwardUnitChangeMode
            organisationId={get(data, 'id')}
            organizationMode={get(data, 'organizationMode')}
            onClose={() => this.props.modal(null)}
          />
        </Modal>
        <Modal id="organization-manage-gop" compact customActions>
          <OrganizationManageGOP
              organisationId={get(data, 'id')}
              gopId={get(data, 'parentGOP.id')}
              sgopId={get(data, 'parentSubGOP.id')}
              onClose={() => this.props.modal(null)}
          />
        </Modal>
      </div>
    )
  }
}

export default AwardUnitsOverview
